import { COMPONENT_TYPE, SEND_DATA } from '../constants';
import { LoadingManager } from '../managers/LoadingManager';
import { ModalManager } from '../managers/ModalManager';
import { ajax } from './apiUtils';
import { getDataAll } from './dataUtils';
import { insertHtmlWithScripts } from './domUtils';
import { appendFormData } from './formUtils';

export class SendData {
  constructor({ data = {}, confirm = null, formData, url, progressBar = false, messageAuto = true, elem = null, uuidKey = null, type = 'POST', headers = {[COMPONENT_TYPE]: SEND_DATA}, loading = null, redirect = null }) {
    this._headers = headers;
    this._messageAuto = messageAuto;
    this._then = this._defaultThen;
    this._catch = this._defaultCatch;
    this._progressBar = progressBar;
    this._type = type;
    this._uuidKey = uuidKey;
    this._fromData = formData;
    if (confirm && !window.confirm(confirm)) {
      this.exp = Promise.reject();
      return;
    }
    if(!url) {
      if (redirect) {
        url = Redirect.route(redirect);
      }
    }
    this._isChained = false; // Добавляем флаг для отслеживания цепочки
    this._loading = loading;
    if (loading) {
      LoadingManager.show(loading);
    }
    this.exp = this._sendData(Object.assign(getDataAll(elem), data, window.breadcrumb_data ?? {}), url);
    this.exp.finally(() => {
      if (loading === false) {
        LoadingManager.hide();
      }
    });
  }

  _sendData(data, url) {
    if (this._progressBar) {
      this._progressBarModal = new ModalManager({ url: '/modal/progressBarModal' });
      this._progressBarModal.open();
    }
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
      let formData = new FormData();

      if (data._FILES) {
        for (const [key, fileList] of Object.entries(data._FILES)) {
          Array.from(fileList).forEach((file, index) => {
            formData.append(`${key}[${index}]`, file);
          });
        }
        delete data._FILES;
      }

      appendFormData(formData, data);
      if (this._fromData) {
        if (this._fromData instanceof FormData) {
          this._fromData.forEach((value, key) => {
            formData.append(key, value);
          });
        } else {
          Object.entries(this._fromData).forEach(([key, value]) => {
            formData.append(key, value);
          });
        }
      }

      ajax({
        headers: this._headers,
        url,
        type: this._type,
        data: formData,
        processData: false,
        contentType: false,
        uuid_key: this._uuidKey,
        success: (answer, status, responseData) => {
          if (this._then && !this._isChained) {
            this._then({ answer, status, responseData });
          }

          if (this._progressBar) this._progressBarModal.closeModal();
          this._proccesAnswer(answer);
          resolve({ answer, status, responseData });
        },
        error: (xhr, status, error) => {
          console.log(xhr, status, error);
          if (xhr.responseText.alert) alert(xhr.responseText.alert);
          window.MessageManager.processResponse(xhr.responseText);
          if (typeof xhr.responseText == 'string' && xhr.responseText.search(/<div class="modal fade" /) !== -1) {
            const modal = new ModalManager({
              response: xhr.responseText
            });
            modal.clearResponse().renderModal();
          }

          if (this._catch && !this._isChained) {
            this._catch({ responseData: xhr, answer: xhr.responseText, status, error });
          }

          reject({ responseData: xhr, answer: xhr.responseText, status, error });
        }
      });
    });
  }

  _proccesAnswer(answer) {
    if (answer.alert_message) {
      alert(answer.alert_message);
    }
    if (this._messageAuto) {
      window.MessageManager.processResponse(answer);
      if (answer && answer.messages) {
        answer.messages = null;
      }
    }
  }

  _defaultThen(response) {
    const responseData = (response && response.responseData) || {};
    const statusCode = response && (response.status || responseData.status);
    window.MessageManager.processResponse(response);

    if (response && response.answer && response.answer.messages) {
      response.answer.messages = null;
    }

    const additionalHeaders = responseData.headers || {};
    const newUrl = responseData.url || additionalHeaders['X-Redirect-URL'] || additionalHeaders['Location'] || additionalHeaders['location'] || window.location.href;

    // Если сервер вернул реальный редирект (302) или флаг redirected — выполнить полноценную навигацию
    if (responseData.redirected || statusCode === 302) {
      window.location.href = newUrl;
      return;
    }

    // По-умолчанию вставляем HTML и обновляем историю
    if ((responseData.redirected || statusCode === 302) && response && response.answer) {
      const htmlContent = response.answer;
      insertHtmlWithScripts({ html: htmlContent, parent: document.body, replaceParent: true });
      history.pushState({ page: newUrl }, '', newUrl);
    }
  }

  _defaultCatch() { }

  then(onFulfilled, onRejected) {
    if (typeof onFulfilled === 'function') {
      this._isChained = true;
      const newPromise = this.exp.then(onFulfilled, onRejected);

      const chainable = Object.create(SendData.prototype);
      chainable.exp = newPromise;
      chainable._then = null;
      chainable._catch = this._catch;
      chainable._isChained = true;

      return chainable;
    }

    // Если then() вызывается без параметров (для проверки thenable)
    return this.exp.then(onFulfilled, onRejected);
  }

  catch(onRejected) {
    this._isChained = true;
    const newPromise = this.exp.catch(onRejected);

    const chainable = Object.create(SendData.prototype);
    chainable.exp = newPromise;
    chainable._then = this._then;
    chainable._catch = null;
    chainable._isChained = true;

    return chainable;
  }

  finally(onFinally) {
    this._isChained = true;
    const newPromise = this.exp.finally(onFinally);

    const chainable = Object.create(SendData.prototype);
    chainable.exp = newPromise;
    chainable._then = this._then;
    chainable._catch = this._catch;
    chainable._isChained = true;

    return chainable;
  }

  valueOf() {
    return this.exp;
  }
}